import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { CheckoutItemRemovedTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackCheckoutItemRemovedFunctionArgs {
  readonly product: Product;
}

interface TrackCheckoutItemRemovedFunction {
  (args: TrackCheckoutItemRemovedFunctionArgs): void;
}

interface UseTrackCheckoutItemRemovedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackCheckoutItemRemovedFunction {
  (agrs: UseTrackCheckoutItemRemovedFunctionArgs): TrackCheckoutItemRemovedFunction;
}

const useTrackCheckoutItemRemoved: UseTrackCheckoutItemRemovedFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<CheckoutItemRemovedTrackingEvent>();

  const trackCheckoutItemRemoved: TrackCheckoutItemRemovedFunction = useCallback(
    ({ product }) => {
      emitUserEvent({
        event: TrackingEventName.CHECKOUT_ITEM_REMOVED,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        product,
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackCheckoutItemRemoved;
};

export { useTrackCheckoutItemRemoved };
